import JustValidate from 'just-validate';

const employmentForm = document.getElementById('employment_form');
const validator = new JustValidate('#employment_form');

window.onload = function () {
  validator
    .addField('#name', [
      {
        rule: 'required',
        errorMessage: 'Ime i prezime je obavezno',
      },
    ])
    .addField('#address', [
      {
        rule: 'required',
        errorMessage: 'Adresa je obavezna',
      },
    ])
    .addField('#phone', [
      {
        rule: 'required',
        errorMessage: 'Telefon je obavezan',
      },
    ])
    .addField('#position', [
      {
        rule: 'required',
        errorMessage: 'Pozicija je obavezna',
      },
    ])
    .addField('#email', [
      {
        rule: 'required',
        errorMessage: 'E-mail je obavezan',
      },
      {
        rule: 'email',
        errorMessage: 'Email adresa koju ste uneli je nevažeća.',
      },
    ])

    .addField('#agree', [
      {
        rule: 'required',
        errorMessage: "Prihvatanje uslova je obavezno.",
      },
    ],
      {
        errorsContainer: '#terms-error',
      }
    ).onSuccess((() => {
      employmentForm.submit()
    })).onFail((() => {
      employmentForm.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'start' });
    }))
};